const actions = {
    CUSTOMER_SCHEDULEINSTANCE_DETAILS_START: 'CUSTOMER_SCHEDULEINSTANCE_DETAILS_START',
    CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS: 'CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS',
    CUSTOMER_SCHEDULEINSTANCE_DETAILS_FAILURE: 'CUSTOMER_SCHEDULEINSTANCE_DETAILS_FAILURE',

    CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_START: 'CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_START',
    CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS: 'CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS',
};

export default actions;